var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="tooltip tooltip--day '+
((__t=( cssClass ))==null?'':_.escape(__t))+
'" style="z-index: 99999; transform: translate(-50%, 0)">\n  <div class="tooltip__content js-tooltip-content position--center position--bottom is-enabled is-active">\n    <i class="arrow"></i>\n    <div>\n      ';
 if (linkUrl) { 
__p+='\n        <a target="_blank" href="'+
((__t=( linkUrl ))==null?'':_.escape(__t))+
'" style="white-space: nowrap">\n      ';
 } 
__p+='\n          <strong><i class="icon--clone icon--auto-width"></i></strong> '+
((__t=( popoverMessage ))==null?'':_.escape(__t))+
'\n      ';
 if (linkUrl) { 
__p+='\n        </a>\n      ';
 } 
__p+='\n      </a>\n    </div>\n  </div>\n</div>\n';
}
return __p;
};
